import { Dialog } from '../../../layouts/Dialog';

export function AuthError() {
  return (
    <Dialog dialogId="authRejected">
      <div className="mt-[70vh] grid h-16 w-60 place-content-center bg-transparent">
        <div className="rounded-2xl bg-gray-50/70 px-3 py-2 text-sm backdrop-blur-sm dark:bg-gray-900/90">
          <p>Your session is already expired</p>
          <p>Please login again...</p>
        </div>
      </div>
    </Dialog>
  );
}
